import { connect } from 'react-redux'
import {
  selectShowDemoMailboxBar,
  selectDoesCurrentMailboxHaveState,
  selectIsSettingUpTheCurrentMailBox,
} from 'selectors/mailboxes'
import {
  selectShowExpiredBilling,
  selectShowPendingCancellation,
  selectCancelsAt,
  selectShowCreditCardExpireSoon,
  selectShowCreditCardExpired,
  selectPrimaryCreditCard,
  selectShowLastBillingFailed,
  selectShowTrialMessage,
  selectDaysLeftBeforeExpiring,
} from 'ducks/billing/selectors'
import { selectShowBillingPlanUsageLimited } from 'ducks/billing/selectors/usage'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import { selectGitHubNeedsReinstall } from 'ducks/integrations/github'
import { selectIsWidgetFromUrlDisconnected } from 'ducks/widgets/selectors/widgets'
import { selectShowTwitterDeprecation } from 'ducks/integrations/twitter/selectors'
import { selectSearchesRequestState } from 'selectors/search'
import {
  selectShowContinueForwardingSetupBar,
  selectShowContinueForwardingSetupPane,
} from 'selectors/layout'
import AppNoticesView from './view'

const select = state => {
  const {
    loaded: isSearchesLoaded,
    error: isSearchesError,
  } = selectSearchesRequestState(state)

  return {
    showDemoMailboxBar: selectShowDemoMailboxBar(state),
    showExpiredBilling: selectShowExpiredBilling(state),
    showGitHubReauth: selectGitHubNeedsReinstall(state),
    showPendingCancellation: selectShowPendingCancellation(state),
    showCreditCardExpireSoon: selectShowCreditCardExpireSoon(state),
    showCreditCardExpired: selectShowCreditCardExpired(state),
    showLastBillingFailed: selectShowLastBillingFailed(state),
    creditCard: selectPrimaryCreditCard(state),
    cancelsAt: selectCancelsAt(state),
    showTrialMessage: selectShowTrialMessage(state, 'inbox'),
    trialDaysLeft: selectDaysLeftBeforeExpiring(state, 'inbox'),
    isManager: selectCurrentUserIsAdminOrOwner(state),
    isCurrentMailboxConfirmedOrUnconfirmed: selectDoesCurrentMailboxHaveState(
      state,
      ['unconfirmed'],
      null,
      ['FORWARDING']
    ),
    isCurrentMailboxDisconnected: selectDoesCurrentMailboxHaveState(state, [
      'disconnected',
    ]),
    isCurrentMailboxConfirmedOrUnconfirmedLegacy: selectDoesCurrentMailboxHaveState(
      state,
      ['unconfirmed'],
      null,
      ['LEGACY']
    ),
    isWidgetFromUrlDisconnected: selectIsWidgetFromUrlDisconnected(state),
    showTwitterDeprecation: selectShowTwitterDeprecation(state),
    isSettingUpTheCurrentMailBox: selectIsSettingUpTheCurrentMailBox(state),
    showContinueForwardingSetupPane: selectShowContinueForwardingSetupPane(
      state
    ),
    showContinueForwardingSetupBar: selectShowContinueForwardingSetupBar(state),
    isSearchesLoaded: isSearchesLoaded && !isSearchesError,
    showBillingPlanUsageLimited: selectShowBillingPlanUsageLimited(state),
  }
}

export default connect(select)(AppNoticesView)
